/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button, sizes, TypeRampV2 } from '@smartsheet/lodestar-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { initiateSmartsheetSignIn } from '../../../../utils/signIn';
import { SignInStage } from '../../../pages/SignIn/SignIn';
import { Divider } from '../styled';

export const SignInMethodSelection = ({
  setStage,
  isLoginWithBridgeEnabled,
}: {
  setStage: React.Dispatch<React.SetStateAction<SignInStage>>;
  isLoginWithBridgeEnabled: boolean;
}) => {
  const { t: translate } = useTranslation();
  const signInWithBridgeCreds = () => {
    setStage(SignInStage.SIGN_IN_EMAIL_PASSWORD);
  };

  return (
    <React.Fragment>
      <TypeRampV2 system="lodestar" variant="headlineMedium">
        {translate('signin:signinToBridge')}
      </TypeRampV2>
      <div
        css={css`
          padding-top: ${sizes.large}px;
        `}
      >
        <Button
          appearance="primary"
          shouldFitContainer={true}
          onClick={initiateSmartsheetSignIn}
        >
          {translate('signin:signinWithSmartsheet')}
        </Button>
        {isLoginWithBridgeEnabled ? (
          <React.Fragment>
            <Divider />
            <Button
              appearance="secondary"
              shouldFitContainer={true}
              onClick={signInWithBridgeCreds}
            >
              {translate('signin:signinWithBridge')}
            </Button>
          </React.Fragment>
        ) : null}
      </div>
    </React.Fragment>
  );
};
